{
    "SidebarMenu_Reporting_Reporting": "Analyses",
    "SidebarMenu_Reporting_Insights": "Inzichten",
    "SidebarMenu_Reporting_Presence": "Aanwezigheid",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Enterprise Bedrijf toevoegen +",
    "SidebarMenu_FastProvisioning_UserManagement": "Gebruikersbeheer",
    "SidebarMenu_FastProvisioning_QueueManagement": "Wachtrijbeheer",
    "SidebarMenu_Admin_Devices": "Apparaten",
    "SidebarMenu_Admin_Agents": "Agenten",
    "SidebarMenu_Admin_Directory": "Directory",
    "SidebarMenu_Admin_Codes": "Codes",
    "SidebarMenu_Admin_Partitions": "Partities",
    "SidebarMenu_Admin_TelephonyServers": "Telefonieservers",
    "SidebarMenu_Admin_CME": "CME",
    "SidebarMenu_Admin_AppUsers": "Gebruikers",
    "SidebarMenu_Admin_Recording": "Opname",
    "SidebarMenu_Admin_Messages": "Berichten",
    "SidebarMenu_Admin_Database": "Databank",
    "SidebarMenu_StatusTools_Licences": "Licenties",
    "SidebarMenu_StatusTools_Logging": "Loggen",
    "SidebarMenu_StatusTools_LogManagement": "Logbeheer",
    "SidebarMenu_StatusTools_AuditTrail": "Controlepad",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "Status van de TelSys-module",
    "SidebarMenu_StatusTools_CallControl": "Oproepbeheer",
    "SidebarMenu_StatusTools_ServerStatus": "Serverstatus",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Clientconfiguratie",
    "SidebarMenu_Admin_CRM_Configuration": "CRM-integratie",
    "SidebarMenu_Reporting_CXScore": "CX-score",
    "SidebarMenu_Admin_Overview": "Overzicht"
}